module.exports = __webpack_public_path__ + "static/media/griechischesbad_tn.f2962167.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/griechischesbad_tn.jpg
// module id = 768
// module chunks = 0